export const dataTypes = [
  'poshak',
  'pagadi',
  'mukut',
  'mala',
  'durga',
  'idols',
  'jhoola',
  'singhasan',
  'lp',
]
